module.exports = __webpack_public_path__ + "387c35855354f3e129063ef8c1ae3223.svg";